import React, { memo } from 'react';
import styled from "@nexus/lib-react/dist/theme/styled";
import {Snackbar} from "@nexus/lib-react/dist/core/Snackbar/Snackbar";
import {mq} from "../../../../../commons/styles";
import {useI18n} from "../../../../../i18n";

const SnackbarWrapper = styled(Snackbar)`
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  bottom: 24px;

  ${mq.desktop} {
    bottom: 56px;
  }
`;

const Dac7SnackbarSubmitting = styled(SnackbarWrapper)``;
const Dac7SnackbarSuccess = styled(SnackbarWrapper)`
  background-color: ${({ theme }) => theme.colors["background-brand-secondary"]};
  color: #002F34;
  &::before{
    content: '🎉'
  }
`;
const Dac7SnackbarError = styled(SnackbarWrapper)``;

interface Props {
  type: "loading" | "success" | "error";
}

const Dac7Snackbar = ({type}: Props) => {
  const i18n = useI18n();

  switch(type) {
  case "loading":
    return <Dac7SnackbarSubmitting>{i18n`dlv_dac7_snackbar_submitting`}</Dac7SnackbarSubmitting>;
  case "success":
    return <Dac7SnackbarSuccess>{i18n`dlv_dac7_snackbar_submit_success`}</Dac7SnackbarSuccess>;
  default:
    return <Dac7SnackbarError>{i18n`dlv_dac7_snackbar_submit_error`}</Dac7SnackbarError>;
  }
}

export default memo(Dac7Snackbar);
